import React, { ReactNode } from 'react'

import { NotificationController, NotificationTemplate } from 'core-components/library/popup'
import { INotificationPopup } from 'core-components/library/popup/notification/Notification'
import { INotificationTemplate } from 'core-components/library/popup/notification/NotificationTemplate'

export const success = (message: string, autoClose: boolean = true) => {
  showNotification(message, { type: 'success', autoHide: autoClose })
}

export const fail = (message: string, autoClose: boolean = true) => {
  showNotification(message, { type: 'danger', autoHide: autoClose })
}

export const warning = (message: string, autoClose: boolean = true) => {
  showNotification(message, {
    type: 'default',
    autoHide: autoClose,
  })
}

export const showSuccess = (message: ReactNode, options?: TNotificationHideOptions) => {
  return showNotification(message, {
    type: 'success',
    ...(options || {}),
  })
}

export const showError = (message: ReactNode, options?: TNotificationHideOptions) => {
  return showNotification(message, {
    type: 'danger',
    ...(options || {}),
  })
}

export const showWarning = (message: ReactNode, options?: TNotificationHideOptions) => {
  return showNotification(message, {
    type: 'default',
    ...(options || {}),
  })
}

const showNotification = (
  message: ReactNode,
  { id, type, autoHide = true, autoHideDuration }: TNotificationOptions
) => {
  return NotificationController.show({
    id,
    autoHide,
    autoHideDuration,
    content: (contentData) => (
      <NotificationTemplate
        closePopup={contentData.close}
        content={message}
        closeButtonVisible={true}
        type={type}
      />
    ),
  })
}

export const closeNotification = (id: string) => NotificationController.close(id)

type TNotificationHideOptions = Pick<INotificationPopup, 'autoHide' | 'autoHideDuration'> & {
  id?: string
}
type TNotificationOptions = TNotificationHideOptions & Pick<INotificationTemplate, 'type'>
